
import apiClient from "./apiClient";
import axios from "./axiosConfig"; // Keep old axios for backward compatibility
import API_BASE_URL from "./apiConfig";

// Note: We're keeping both apiClient (new enhanced client) and axios (old client)
// Gradually migrate endpoints to use apiClient for automatic token refresh
// For now, keeping existing imports to maintain backward compatibility

export const login = async (username, password) => {
  const data = {
    email: username,
    password: password,
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/login`,
    data
  );
  return response;
};

export const register = async (userData) => {
  const data = {
    lastName: userData.lastName,
    firstName: userData.firstName,
    phoneNumber: userData.phoneNumber,
    email: userData.email,
    password: userData.password,
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/register`,
    data
  );

  return response;
};

export const registerbyPhoneNumber = async (userData) => {
  const data = {
    lastName: userData.lastName,
    firstName: userData.firstName,
    phoneNumber: userData.phoneNumber,
    email: userData.email
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/register-by-phoneNumber`,
    data
  );

  return response;
};

export const registerbyEmail = async (userData) => {
  console.log("Registering user with data:", userData);
  const data = {
    lastName: userData.lastName,
    firstName: userData.firstName,
    phoneNumber: userData.phoneNumber,
    email: userData.email
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/register-by-email`,
    data
  );

  console.log("API response:", response);         

  return response;
};

//generate-sms-code
export const generateSmsCode = async (phoneNumber) => {
  
  const data = {
    phoneNumber: phoneNumber,
    lang: "en",
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/generate-sms-code`,
    data
  );
  return response;
};

//verify-sms-code
export const VerifySmsCode = async (phoneNumber, code) => {
  const data = {
    phoneNumber: phoneNumber,
    code: code,
    lang: "en",
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/verify-sms-code`,
    data,
    { withCredentials: true } // Auth endpoints need this for refresh token cookie
  );
  return response;
};

//generate-email-code
export const generateEmailCode = async (email) => {
  const data = {
    email: email,
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/generate-email-code-2`,
    data
  );
  return response;
};

//verify-email-code
export const VerifyEmailCode = async (email, resetCode) => {
  const data = {
    email: email,
    resetCode: resetCode
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/verify-email-code`,
    data,
    { withCredentials: true } // Auth endpoints need this for refresh token cookie
  );
  return response;
};

// forgot password api is currently not used
export const forgotPassword = async (username) => {
  const data = {
    email: username,
  };

  const response = await axios.post(
    `${API_BASE_URL}/account/api/forgot-password`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};

// Using apiClient for automatic token refresh
export const getUserProfile = async (id) => {
  const response = await apiClient.get(
    `/account/${id}`
  );

  return response;
};

export const updateUserProfile = async (userData) => {
  const response = await axios.put(
    `${API_BASE_URL}/account`,
    userData,

  );

  return response;
};



export const updatePassword = async (oldPassword, newPassword, userId) => {
  const response = await axios.put(
    `${API_BASE_URL}/account/update-password`,
    { oldPassword, newPassword, userId },

  );

  return response;
};

// get pets - Using apiClient for automatic token refresh
export const getPets = async (userId, page = 1) => {
  const response = await apiClient.get(
    `/pets/pet-list/${userId}?page=${page}`
  );

  return response;
};

//get PTag Information for Admin
export const getTagInfoforSupplier = async (orderId) => {
  const response = await axios.get(
    `${API_BASE_URL}/orderVerification/supplier/${orderId}`,

  );

  return response;
};

export const getOrderInfo = async (tempId) => {
  const response = await axios.get(
    `${API_BASE_URL}/orderVerification/ordersInfo/${tempId}`,

  );

  return response;
};

//get PTag Information for WhatsApp Dynamic Link
export const getTagInfoforWhatsAppLink = async (_id) => {
  const response = await axios.get(
    `${API_BASE_URL}/orderVerification/whatsapp-order-link/${_id}`,

  );

  return response;
};

export const updateTagInfoforSupplier = async (tagId, tagData) => {
  const formData = new FormData();

  // Add image files if they exist
  if (tagData.qrImageFile) {
    formData.append("qrImage", tagData.qrImageFile);
  }
  
  if (tagData.petImageFile) {
    formData.append("petImage", tagData.petImageFile);
  }

  // Add all other form fields
  Object.entries(tagData).forEach(([key, value]) => {
    if (key !== "qrImageFile" && key !== "petImageFile" && value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  const response = await axios.put(
    `${API_BASE_URL}/orderVerification/supplier/${tagId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response;
};

//get PTag Information for Admin
export const getTagInfo = async (tagId) => {
  const response = await axios.get(
    `${API_BASE_URL}/orderVerification/${tagId}`,

  );

  return response;
};

export const updateTagInfo = async (tagId, tagData) => {
  const response = await axios.put(
    `${API_BASE_URL}/orderVerification/${tagId}`,
    tagData,

  );
  return response;
};

// create pet
export const createPet = async (userId, petData) => {
  // Create FormData for file upload
  const formData = new FormData();

  // Add multiple image files if they exist
  if (petData.imageFiles) {
    petData.imageFiles.forEach(file => {
      formData.append("files", file);
    });
  }

  // Add all other form fields including userId
  formData.append("userId", userId);
  Object.entries(petData).forEach(([key, value]) => {
    if (key !== "imageFiles" && value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  const response = await axios.post(
    `${API_BASE_URL}/pets/create-pet-basic-info-with-image`,
    formData,
    {
      headers: {
      },
    }
  );

  return response;
};

// delete pet - Using apiClient for automatic token refresh
export const deletePet = async (petId) => {
  console.log("Deleting pet with ID:", petId);
  const response = await apiClient.delete(
    `/pets/${petId}`
  );

  return response;
};

// get pet by id - Using apiClient for automatic token refresh
export const getPetBasicInfo = async (petId) => {
  const response = await apiClient.get(
    `/pets/${petId}/basic-info`
  );

  return response;
};

export const getPetInfobyTagId = async (tagId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/getPetInfobyTagId/${tagId}`,

  );

  return response;
};

// update pet basic info
// export const updatePetBasicInfo = async (petId, petData) => {
//   const response = await axios.put(
//     `https://api.phealth.com.hk/api/pets/${petId}/basic-info`,
//     petData,
//     {
//       headers: {
//         "X-API-KEY": process.env.REACT_APP_PTAG_ACCESS_ID,
//         "X-API-SECRET": process.env.REACT_APP_PTAG_SECRET,
//       },
//     }
//   );

//   return response;
// };

// Using apiClient for automatic token refresh
export const updatePetBasicInfo = async (petId, petData) => {
  const response = await apiClient.put(
    `/pets/${petId}/basic-info`,
    petData
  );

  return response;
};

// update pet image
export const updatePetImage = async (basicInfo, petId, removedImageIndices = []) => {
  const formData = new FormData();
  formData.append("petId", petId);

  // Add multiple image files if they exist
  if (basicInfo.imageFiles) {
    basicInfo.imageFiles.forEach(file => {
      formData.append("files", file);
    });
  }

  // Add removed image indices as an array
  if (removedImageIndices.length > 0) {
    formData.append("removedIndices", JSON.stringify(removedImageIndices));
  }

  Object.entries(basicInfo).forEach(([key, value]) => {
    if (key !== "imageFiles" && value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  const response = await axios.post(
    `${API_BASE_URL}/pets/updatePetImage`,
    formData,
    {
      headers: {
      },
    }
  );
  return response;
};

// get pet detail
export const getPetDetail = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/${petId}/detail-info`,

  );

  return response;
};

// update pet detail
export const updatePetDetail = async (petId, petData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/detail-info`,
    petData,

  );

  return response;
};

// create transfer record
export const createTransferRecord = async (petId, transferData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/detail-info/transfer`,
    transferData,

  );

  return response;
};

// update transfer record
export const updateTransferRecord = async (petId, transferId, transferData) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/detail-info/transfer/${transferId}`,
    transferData,

  );

  return response;
};

// update transfer record
export const updateNGOtransfer = async (petId, transferData) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/detail-info/NGOtransfer`,
    transferData,

  );
  return response;
};

// delete transfer record
export const deleteTransferRecord = async (petId, transferId) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/${petId}/detail-info/transfer/${transferId}`,

  );

  return response;
};

// get pet medical
export const getPetMedical = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/${petId}/medical-record`,

  );

  return response;
};

// update pet medical
export const updatePetMedical = async (petId, petData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/medical-record`,
    petData,

  );

  return response;
};

// create medical record
export const createMedicalRecord = async (petId, medicalData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/medical-record`,
    medicalData,

  );

  return response;
};

// update medical record
export const updateMedicalRecord = async (
  petId,
  medicalID,
  medicalData
) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/medical-record/${medicalID}`,
    medicalData,

  );

  return response;
};

// delete medical record
export const deleteMedicalRecord = async (petId, medicalID) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/${petId}/medical-record/${medicalID}`,

  );

  return response;
};

// get pet blood test
export const getPetBloodTest = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/${petId}/blood-test-record`,

  );

  return response;
};

export const createBloodTestRecord = async (petId, bloodTestData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/blood-test-record`,
    bloodTestData,
  );

  return response;
};

export const updateBloodTestRecord = async (
  petId,
  bloodTestId,
  bloodTestData
) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/blood-test-record/${bloodTestId}`,
    bloodTestData,

  );

  return response;
};

export const deleteBloodTestRecord = async (petId, bloodTestId) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/${petId}/blood-test-record/${bloodTestId}`,

  );

  return response;
};

// get pet medication
export const getPetMedication = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/${petId}/medication-record`,

  );

  return response;
};

// update pet medication
export const updatePetMedication = async (petId, petData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/medication-record`,
    petData,

  );

  return response;
};

// create medication record
export const createMedicationRecord = async (petId, medicationData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/medication-record`,
    medicationData,

  );

  return response;
};

// update medication record
export const updateMedicationRecord = async ( 
  petId,
  medicationID,
  medicationData
) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/medication-record/${medicationID}`,
    medicationData,

  );

  return response;
};

// delete medication record
export const deleteMedicationRecord = async (petId, medicationID) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/${petId}/medication-record/${medicationID}`,

  );

  return response;
};

// get pet deworm
export const getPetDeworming = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/${petId}/deworm-record`,

  );

  return response;
};

// update pet deworm
export const updatePetDeworming = async (petId, petData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/deworm-record`,
    petData,

  );

  return response;
};

// create deworm record
export const createDewormingRecord = async (petId, dewormingData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/deworm-record`,
    dewormingData,

  );

  return response;
};

// update deworm record
export const updateDewormingRecord = async (
  petId,
  dewormID,
  dewormingData
) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/deworm-record/${dewormID}`,
    dewormingData,

  );
  return response;
};

// delete deworm record
export const deleteDewormingRecord = async (petId, dewormID) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/${petId}/deworm-record/${dewormID}`,

  );

  return response;
};

// update pet vaccination
export const updatePetVaccination = async (petId, petData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/vaccine-record`,
    petData,

  );
  return response;
};

// create vaccination record
export const createVaccinationRecord = async (petId, vaccinationData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/${petId}/vaccine-record`,
    vaccinationData,

  );

  return response;
};

// update vaccination record
export const updateVaccinationRecord = async (
  petId,
  vaccineID,
  vaccinationData
) => {
  const response = await axios.put(
    `${API_BASE_URL}/pets/${petId}/vaccine-record/${vaccineID}`,
    vaccinationData,

  );

  return response;
};

// delete vaccination record
export const deleteVaccinationRecord = async (petId, vaccineID) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/${petId}/vaccine-record/${vaccineID}`,

  );

  return response;
};

// get dog breeds
export const getDogBreeds = async (lang) => {
  const response = await axios.get(
    `${API_BASE_URL}/animal/breed/dog/${lang}`,

  );

  return response;
};

// get cat breeds
export const getCatBreeds = async (lang) => {
  const response = await axios.get(
    `${API_BASE_URL}/animal/breed/cat/${lang}`,

  );

  return response;
};

// get pet vaccination
export const getPetVaccination = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/${petId}/vaccine-record`,

  );
  return response;
};

// get promo code
export const getShopInfo = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/purchase/shop-info`,

  );
  return response;
};

// create pet lost record
export const createPetLostRecord = async (userId, petData) => {
  const formData = new FormData();

  if (petData.imageFiles) {
    petData.imageFiles.forEach(file => {
      formData.append("files", file);
    });
  }

  formData.append("userId", userId);
  Object.entries(petData).forEach(([key, value]) => {
    if (key !== "imageFiles" && value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  const response = await axios.post(
    `${API_BASE_URL}/pets/pet-lost`,
    formData
  );

  return response;
};

// delete pet lost record
export const deletePetLostRecord = async (petId) => {
  const response = await axios.delete(
    `${API_BASE_URL}/pets/pet-lost/${petId}`,

  );

  return response;
};

export const createPetFoundRecord = async (petData) => {
  const formData = new FormData();

  if (petData.imageFiles) {
    petData.imageFiles.forEach(file => {
      formData.append("files", file);
    });
  }

  Object.entries(petData).forEach(([key, value]) => {
    if (key !== "imageFiles" && value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  const response = await axios.post(
    `${API_BASE_URL}/pets/pet-found`,
    formData,
    {
      headers: {
      },
    }
  );
  console.log("API response:", response);

  return response;
};

export const getListofLostPets = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/pet-lost`
  );

  return response;
};

export const getListofFoundPets = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/pets/pet-found`,

  );

  return response;
};

export const sendPtagDetectionEmail = async (name, petTagNumber, currentDateTime, googleMapsLink, email) => {
  const petDetails = {
    name: name,
    tagId: petTagNumber,
    dateTime: currentDateTime,
    locationURL: googleMapsLink,
    email: email,
  };
  const response = await axios.post(
    `${API_BASE_URL}/purchase/send-ptag-detection-email`,
    petDetails,
  );

  return response;
};

// faceID registration
export const RegisterFaceID = async (faceIdData) => {
  const response = await axios.post(
    `${API_BASE_URL}/petBiometrics/register`,
    faceIdData,
  );

  console.log("FaceID registration response:", response, faceIdData);

  return response;
};

export const UploadArrayImages = async (faceIdData) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/upload-array-images`,
    faceIdData,
  );

  console.log("Upload response:", response);

  return response;
};

export const UploadtagUpdateImages = async (tagImages) => {
  const response = await axios.post(
    `${API_BASE_URL}/pets/upload-tag-update-images`,
    tagImages,
  );
  return response;
};

// Get pet facial images
export const getPetFacialImages = async (petId) => {
  const response = await axios.get(
    `${API_BASE_URL}/petBiometrics/${petId}`,
  );
  return response;
};

//get PTag Information for WhatsApp Dynamic Link
export const getNotifications = async (userId) => {
  const response = await axios.get(
    `${API_BASE_URL}/account/${userId}/notifications`,
  );

  return response;
};

export const PostNotifications = async (data) => {
  const response = await axios.post(
    `${API_BASE_URL}/account/${data.userId}/notifications`,
    data,
  );
  return response;
};

export const ArchiveNotifications = async (userId, notificationId) => {
  const response = await axios.put(
    `${API_BASE_URL}/account/${userId}/notifications/${notificationId}`,
  );
  return response;
};


//get All PTags
export const getAllOrders = async (_id) => {
  const response = await axios.get(
    `${API_BASE_URL}/orderVerification/getAllOrders`,
  );

  return response;
};




